<div
  class="full-screen-message body-login"
>
    <div
      class="full-screen-message-container fsm-img-container"
    >
      <img
        class="logo"
        [src]="logoPath"
        alt="logo"
      />
    </div>

    <div class="full-screen-message-container fsm-txt-container">
      <div class="info-text">
        <h3 class="description-text text-center">
          {{'MAIN.ACCOUNT-BLOCKED' | translate}}
        </h3>
        <h3 class="description-text text-center">
          {{'MAIN.ACCOUNT-BLOCKED-INFO' | translate}} {{supportEmail}}
        </h3>
      </div>
    </div>

    <div class="full-screen-message-container fsm-btn-container action-button">
      <div>
        <button
          type="button"
          id="btnBackToLogin"
          (click)="reload()"
          class="btn btn-primary loading-button"
        >
          <span class="loading-button-txt text-center">{{'MAIN.ACCOUNT-BLOCKED-BUTTON-TEXT' | translate}}</span>
        </button>
      </div>
    </div>
</div>
